<div *ngIf="wholesalerSimulation.simulations.length > 0" class="wholesaler-simulation-card">
  <div class="content">
    <table>
      <thead>
        <tr>
          <th>
            <span [matTooltip]="msgTooltipAssiette" [matTooltipPosition]="TooltipPosition.RIGHT">
              Assiette
            </span>
          </th>
          <th>
            <span [matTooltip]="msgTooltipQuantite" [matTooltipPosition]="TooltipPosition.RIGHT">
              Quantité
            </span>
          </th>
          <th>
            <span [matTooltip]="msgTooltipMontantBrutHT" [matTooltipPosition]="TooltipPosition.RIGHT">
              Montant brut HT facturé
            </span>
          </th>
          <th>
            <span [matTooltip]="msgTooltipMontantBrutHTPF" [matTooltipPosition]="TooltipPosition.RIGHT">
              Montant brut HT PF
            </span>
          </th>
          <th>
            <span [matTooltip]="msgTooltipRSFEuro" [matTooltipPosition]="TooltipPosition.RIGHT">
              RSF&nbsp;€
            </span>
          </th>
          <th>
            <span [matTooltip]="msgTooltipRSFPercent" [matTooltipPosition]="TooltipPosition.RIGHT">
              RSF&nbsp;%
            </span>
          </th>
          <th>
            <span [matTooltip]="msgTooltipMontantNetHT" [matTooltipPosition]="TooltipPosition.RIGHT">
              Montant net HT
            </span>
          </th>
          <th>
            <span [matTooltip]="msgTooltipSimulationIndividuelle" [matTooltipPosition]="TooltipPosition.RIGHT">
              Simulation individuelle&nbsp;%
            </span>
          </th>
          <th>
            <span [matTooltip]="msgTooltipSimulationIndividuelleBoite" [matTooltipPosition]="TooltipPosition.RIGHT">
              Simulation individuelle à la boite
            </span>
          </th>
          <th>
            <span [matTooltip]="msgTooltipTotalSimulation" [matTooltipPosition]="TooltipPosition.RIGHT">
              Total Simulation&nbsp;€
            </span>
          </th>
          <th>
            <span [matTooltip]="msgTooltipSimulationRecevoir" [matTooltipPosition]="TooltipPosition.RIGHT">
              Simulation à recevoir
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        @for (base of sortedSimulations; track $index) {
        <tr>
          <td>
            <span [matTooltip]="base.descriptionAssiette || ''" [matTooltipPosition]="TooltipPosition.RIGHT">{{
              base.base }}</span>
          </td>
          <td>{{ base.quantity | customNumberFormat }}</td>
          <td>{{ base.grossAmountExclTax | customNumberFormat }}</td>
          <td>{{ base.grossManufacturerAmountExclTax | customNumberFormat }}</td>
          <td>{{ base.discountEuroExclTax | customNumberFormat }}</td>
          <td>{{ base.discountPercent | customNumberFormat }}</td>
          <td>{{ getBaseNetAmountExclTax(base) | customNumberFormat }}</td>
          <td>
            <input #inputPercentileTarget type="text" name="targetPercentage"
              [value]="(base.grossPercentileTarget | customNumberFormat)" (keyup.enter)="focusNextInput($event)"
              (input)="onTargetPercentageChange(base, $event)" (blur)="onTargetPercentageBlur(base, $event)"
              (focus)="inputPercentileTarget.value === '-' ? (inputPercentileTarget.value = '') : null"
              [disabled]="((base.cooperationTargetBox ?? 0) !== 0) || (base.grossAmountExclTax === 0)" />
          </td>
          <td>
            <input #inputCooperationBox type="text" name="cooperationBox"
              [value]="(base.cooperationTargetBox | customNumberFormat)" (keyup.enter)="focusNextInput($event)"
              (input)="onCooperationBoxChange(base, $event)" (blur)="onCooperationBoxBlur(base, $event)"
              (focus)="inputCooperationBox.value === '-' ? (inputCooperationBox.value = '') : null"
              [disabled]="((base.grossPercentileTarget ?? 0) !== 0) || (base.grossAmountExclTax === 0)" />
          </td>
          <td>{{ base.totalCooperation | customNumberFormat }}</td>
          <td>
            {{
            base.netTotalSimulation === 0 ? '-' : (base.netTotalSimulation | customNumberFormat)
            }}
          </td>
        </tr>
        }
      </tbody>
      <tfoot>
        <tr>
          <td><strong>Total simulé</strong></td>
          <td>{{ getSimulatedTotalQuantity() | customNumberFormat }}</td>
          <td>{{ getSimulatedTotalGrossAmountExclTax() | customNumberFormat }}&nbsp;€</td>
          <td>
            {{ getSimulatedTotalGrossManufacturerAmountExclTax() | customNumberFormat }}&nbsp;€
          </td>
          <td>{{ getSimulatedTotalDiscountableEuroExclTax() | customNumberFormat }}&nbsp;€</td>
          <td>-</td>
          <td>{{ getSimulatedTotalNetAmountExclTax() | customNumberFormat }}&nbsp;€</td>
          <td>{{ getSimulatedIndividualPercent() | customNumberFormat }}</td>
          <td>-</td>
          <td>{{ getSimulatedTotalCooperation() | customNumberFormat }}&nbsp;€</td>
          <td>{{ getSimulatedNetTotalSimulation() | customNumberFormat }}&nbsp;€</td>
        </tr>
        <tr>
          <td><strong>Total</strong></td>
          <td>{{ getTotalQuantity() | customNumberFormat }}</td>
          <td>{{ getTotalGrossAmountExclTax() | customNumberFormat }}&nbsp;€</td>
          <td>{{ getTotalGrossManufacturerAmountExclTax() | customNumberFormat }}&nbsp;€</td>
          <td>{{ getTotalDiscountableEuroExclTax() | customNumberFormat }}&nbsp;€</td>
          <td><input type="text" value="-" disabled /></td>
          <td>{{ getTotalNetAmountExclTax() | customNumberFormat }}&nbsp;€</td>
          <td><input type="text" value="-" disabled /></td>
          <td><input type="text" value="-" disabled /></td>
          <td><input type="text" value="-" disabled /></td>
          <td><input type="text" value="-" disabled /></td>
        </tr>
      </tfoot>
    </table>

    <div class="horizontal-spacer"></div>

    <div style="display:none" class="table-footer">
      <div>
        <label style="display:none">Montant total brut remisable</label>
        <input style="display:none" matInput type="text" [value]="getYearlyGrossTurnover() | customNumberFormat"
          disabled />
      </div>

      <div>
        <label style="display:none">Montant total net remisable</label>
        <input style="display:none" matInput type="text" [value]="getYearlyNetTurnover() | customNumberFormat"
          disabled />
      </div>
    </div>
    <div style="display:none" class="table-footer">
      <div>
        <label style="display:none">CA moyen brut mensuel</label>
        <input style="display:none" matInput type="text" [value]="getAverageMonthlyGrossTurnover() | customNumberFormat"
          disabled />
      </div>

      <div>
        <label style="display:none">CA moyen net mensuel</label>
        <input style="display:none" matInput type="text" [value]="getAverageMonthlyNetTurnover() | customNumberFormat"
          disabled />
      </div>
    </div>
    <div class="table-footer">
      <div>
        <label>Montant net HT des avoirs</label>
        <input matInput type="text" [value]="getYearlyCreditAmountHT() | customNumberFormat" disabled />
      </div>

      <div>
        <label>Ratio montant net HT avoirs/factures</label>
        <input matInput type="text" value="{{getCreditToInvoiceNetHTRatio() | customNumberFormat}}&nbsp;%" disabled />
      </div>
      <div class="white">
        <label [matTooltip]="msgTooltipTotalPercu" [matTooltipPosition]="TooltipPosition.ABOVE">
          Total perçu
        </label>
        <input #inputAmountCollected matInput type="text" class="{{ modifiedAmountCollected() ? 'modified' : '' }}"
          [value]="amountCollected | customNumberFormat"
          (keyup.enter)="inputAmountCollected.blur(); focusNextInput($event)" (blur)="onAmountCollectedBlur($event)"
          (focus)="inputAmountCollected.value = ''" />
      </div>
      <div>
        <label [matTooltip]="msgTooltipResteARecevoir" [matTooltipPosition]="TooltipPosition.ABOVE">
          Reste à recevoir
        </label>
        <input matInput type="text" [value]="amountToCollect | customNumberFormat" disabled />
      </div>
    </div>
  </div>
</div>